import AllowanceApplicationPage from './AllowanceApplicationPage';

export default AllowanceApplicationPage;
